import { render, staticRenderFns } from "./SupportAppAuth.vue?vue&type=template&id=68c39fbc&scoped=true&"
import script from "./SupportAppAuth.vue?vue&type=script&lang=js&"
export * from "./SupportAppAuth.vue?vue&type=script&lang=js&"
import style0 from "./SupportAppAuth.vue?vue&type=style&index=0&id=68c39fbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c39fbc",
  null
  
)

export default component.exports